import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemState } from '@/types';

interface SystemSliceState {
  currentState: SystemState | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: SystemSliceState = {
  currentState: null,
  isLoading: false,
  error: null,
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setSystemState: (state, action: PayloadAction<SystemState>) => {
      state.currentState = action.payload;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setSystemState, setLoading, setError } = systemSlice.actions;
export default systemSlice.reducer; 